/* eslint-disable */
import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { GoogleGenerativeAI } from "@google/generative-ai";
import {
	Box,
	Grid,
	TextField,
	Checkbox,
	FormGroup,
	FormControlLabel,
	Button,
	Paper,
	IconButton,
	Typography
} from "@mui/material";
import { Add, Check, Delete } from "@material-ui/icons";
import * as XLSX from "xlsx";
import { trackPromise } from "react-promise-tracker";
import { api } from "../../../../../../utils/api";
import { VEBConfig } from "../../../../../../constants/vebConfig";
import { Condition, FormField, MetaField, VEB_Plan } from "../../../../../../@types/plan.types";
import { jsonToExcel } from "./SchemaToExcel";
import { LinearProgress } from "@mui/material";
import { Step, StepIconProps, StepLabel, Stepper } from "@material-ui/core";

interface LocationState {
	createdPlan: VEB_Plan;
}
interface ExcelToJsonProps {
	planId: string;
	initialData?: Record<string, any>;
	createdPlan?: any;
}

const ExcelToJson: React.FC = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);
	const planId = queryParams.get("planId");
	const queryGroupNumber = queryParams.get("gn") || "0";

	const { createdPlan } = location.state as LocationState;
	const genAI = new GoogleGenerativeAI("AIzaSyA4Gk0TRz_yfIm35fNbg_lOjmB7gTYWEGY");

	const [step, setStep] = useState(1);
	const [formData, setFormData] = useState<Record<string, any>>(VEBConfig);
	const [file, setFile] = useState<File | null>(null);
	const [loading, setLoading] = useState(false);
	const [jsonOutput, setJsonOutput] = useState<any>(null);
	const steps = ["Coverage", "Benefits", "Age Criteria", "Riders", "excel upload"];

	// --- Step Navigation ---
	// const handleNext = () => {
	// 	console.log("formData", formData);
	// 	if (formData.coverage_for.oprions?.length < 1) {
	// 		alert("Looks like you missed coverage or payment frequency. Please fill them in.");

	// 		setStep(1);
	// 	} else if (formData.pay_frequency.options?.length < 1) {
	// 		alert("Looks like you missed coverage or payment frequency. Please fill them in.");

	// 		setStep(1);
	// 	} else {
	// 		setStep((prev) => Math.min(prev + 1, 5));
	// 	}
	// };
	const handleNext = () => {
		console.log("formData", formData);
		// if (!formData.coverage_for || formData.coverage_for.length === 0) {
		// 	alert("Looks like you missed coverage or payment frequency. Please fill them in.");
		// 	console.log("formData.coverage_for", formData.coverage_for);
		// 	setStep(1);
		// 	return;
		// }

		// if (!formData.pay_frequency || formData.pay_frequency.length === 0) {
		// 	alert("Looks like you missed coverage or payment frequency. Please fill them in.");
		// 	console.log("formData.coverage_for", formData.pay_frequency);
		// 	setStep(1);
		// 	return;
		// } else {
		// 	console.log("formData.coverage_for", formData.pay_frequency);

		// 	setStep((prev) => Math.min(prev + 1, 5));
		// }
		setStep((prev) => Math.min(prev + 1, 5));
	};

	const handleBack = () => setStep((prev) => Math.max(prev - 1, 1));

	const stepFields = (currentStep: number) => VEBConfig.filter((f: any) => f.step === currentStep);

	const handleChange = (name: string, value: any) => {
		setFormData((prev) => ({ ...prev, [name]: value }));
	};

	const GreenStepIcon = (props: StepIconProps) => {
		const { completed, active, icon } = props;

		const circleStyle: React.CSSProperties = {
			width: 30,
			height: 30,
			borderRadius: "50%",
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			fontSize: 18,
			fontWeight: 600,
			color: "white",
			background: completed
				? "linear-gradient(135deg, #4caf50, #2e7d32)"
				: active
				? "linear-gradient(135deg, #81c784, #4caf50)"
				: "#bdbdbd",
			border: "2px solid rgba(0,0,0,0.1)",
			boxShadow: active ? "0 0 12px rgba(76, 175, 80, 0.6)" : "0 2px 6px rgba(0,0,0,0.15)",
			transition: "all 0.3s ease, transform 0.2s ease",
			transform: active ? "scale(1.1)" : "scale(1)"
		};

		return <div style={circleStyle}>{completed ? <Check style={{ fontSize: 24 }} /> : icon}</div>;
	};

	const renderField = (field: FormField | MetaField, parentKey?: string) => {
		const fieldKey = parentKey ? `${parentKey}.${field.name}` : field.name;

		if (field.condition) {
			const conditions = Array.isArray(field.condition) ? field.condition : [field.condition];
			const evaluateCondition = (cond: Condition): boolean => {
				const currentValue = formData[cond.field];
				let match = false;

				if (cond.includes !== undefined) {
					if (Array.isArray(currentValue)) {
						match = currentValue.includes(cond.includes);
					}
				} else if (cond.value !== undefined) {
					const conditionValues = Array.isArray(cond.value) ? cond.value : [cond.value];
					match = conditionValues.includes(currentValue);
				}

				return cond.not ? !match : match; // ← not is applied per-clause
			};

			const operator = field.conditionOperator === "OR" ? "OR" : "AND";

			const shouldRender =
				operator === "OR" ? conditions.some(evaluateCondition) : conditions.every(evaluateCondition);

			if (!shouldRender) return null;
		}

		if (field.type === "meta" && field.fields) {
			return (
				<Box
					key={fieldKey}
					sx={{
						ml: parentKey ? 2 : 0,
						mb: 2,
						pl: parentKey ? 2 : 0,
						borderLeft: parentKey ? "2px solid #e0e0e0" : "none"
					}}
				>
					{field.label && (
						<Typography fontWeight={600} sx={{ mb: 1 }}>
							{field.label}
						</Typography>
					)}
					{field.fields.map((subField: any) => renderField(subField, fieldKey))}
				</Box>
			);
		}

		if (field.type === "array") {
			const arrayValues: string[] = formData[fieldKey] || [""];
			const handleArrayChange = (index: number, value: string) => {
				const updated = [...arrayValues];
				updated[index] = value;
				handleChange(
					fieldKey,
					updated.filter((v) => v.trim() !== "")
				);
			};
			const addItem = () => handleChange(fieldKey, [...arrayValues, ""]);
			const removeItem = (index: number) =>
				handleChange(
					fieldKey,
					arrayValues.filter((_, i) => i !== index)
				);

			return (
				<Grid container spacing={2} key={fieldKey} sx={{ mb: 2 }}>
					<Grid item xs={12} md={3}>
						<Typography fontWeight={600}>{field.label}</Typography>
					</Grid>
					<Grid item xs={12} md={9}>
						{arrayValues.map((val, index) => (
							<Grid container spacing={1} alignItems="center" key={index} sx={{ mb: 1 }}>
								<Grid item xs={10}>
									<TextField
										fullWidth
										size="small"
										variant="outlined"
										value={val}
										onChange={(e) => handleArrayChange(index, e.target.value)}
									/>
								</Grid>
								<Grid item xs={2}>
									<IconButton color="error" onClick={() => removeItem(index)}>
										<Delete />
									</IconButton>
								</Grid>
							</Grid>
						))}
						<Button variant="contained" startIcon={<Add />} onClick={addItem}>
							Add
						</Button>
					</Grid>
				</Grid>
			);
		}

		if (field.type === "multiselect") {
			const selectedValues: string[] = formData[fieldKey] || [];
			const toggleOption = (option: string) => {
				if (selectedValues.includes(option))
					handleChange(
						fieldKey,
						selectedValues.filter((v) => v !== option)
					);
				else handleChange(fieldKey, [...selectedValues, option]);
			};
			return (
				<Grid container key={fieldKey} spacing={2} sx={{ mb: 2 }}>
					<Grid item xs={12} md={3}>
						<Typography fontWeight={600}>{field.label}</Typography>
					</Grid>
					<Grid item xs={12} md={9}>
						<FormGroup>
							{field.options?.map((option) => (
								<FormControlLabel
									key={option}
									control={
										<Checkbox
											checked={selectedValues.includes(option)}
											onChange={() => toggleOption(option)}
										/>
									}
									label={option}
								/>
							))}
						</FormGroup>
					</Grid>
				</Grid>
			);
		}

		if (field.type === "checkbox") {
			return (
				<Grid container key={fieldKey} spacing={2} sx={{ mb: 2 }}>
					<Grid item xs={12} md={3}>
						<Typography fontWeight={600}>{field.label}</Typography>
					</Grid>
					<Grid item xs={12} md={9}>
						<FormGroup>
							<FormControlLabel
								control={
									<Checkbox
										checked={Boolean(formData[fieldKey])}
										onChange={(e) => handleChange(fieldKey, e.target.checked)}
									/>
								}
								label=""
							/>
						</FormGroup>
					</Grid>
				</Grid>
			);
		}

		if (field.type === "file") {
			return (
				<Grid container spacing={2} key={fieldKey} sx={{ mb: 2 }}>
					<Grid item xs={12} md={3}>
						<Typography fontWeight={600}>{field.label}</Typography>
					</Grid>
					<Grid item xs={12} md={9}>
						<Button variant="outlined" component="label">
							Upload File
							{/* <input type="file" hidden onChange={(e) => e.target.files && setFile(e.target.files[0])} /> */}
							<input
								type="file"
								hidden
								onChange={async (e) => {
									if (e.target.files && e.target.files[0]) {
										const selectedFile = e.target.files[0];
										setFile(selectedFile); // store the file in state
										setLoading(true); // start loading

										try {
											await handleConvert(); // call handleConvert immediately
										} catch (err) {
											console.error("Error converting file:", err);
										} finally {
											setLoading(false); // stop loading
										}
									}
								}}
							/>
						</Button>
						{file && (
							<Typography variant="body2" sx={{ mt: 1 }}>
								{file.name}
							</Typography>
						)}
					</Grid>
				</Grid>
			);
		}

		return (
			<Grid container spacing={2} key={fieldKey} sx={{ mb: 2 }}>
				<Grid item xs={12} md={3}>
					<Typography fontWeight={600}>{field.label}</Typography>
				</Grid>
				<Grid item xs={12} md={8}>
					<TextField
						fullWidth
						size="small"
						variant="outlined"
						type={field.type === "number" ? "number" : "text"}
						value={formData[fieldKey] || ""}
						onChange={(e) => handleChange(fieldKey, e.target.value)}
					/>
				</Grid>
			</Grid>
		);
	};

	// --- Helpers ---
	const generateBenefitOptions = (min: number, max: number, step: number) => {
		const options = [];
		for (let i = Number(min); i <= Number(max); i += Number(step)) options.push(i);
		return options;
	};

	const generateSpecificAgeListOptions = (min: number, max: number) => {
		const options = [];
		for (let i = Number(min); i <= Number(max); i++) options.push(i);
		return options;
	};

	const handleConvert = async () => {
		if (!file) {
			alert("Please select a file first!");
			return;
		}
		setLoading(true);

		const reader = new FileReader();
		reader.onload = async (e) => {
			const data = new Uint8Array(e.target?.result as ArrayBuffer);
			const workbook = XLSX.read(data, { type: "array" });
			const sheetName = workbook.SheetNames[0];
			const worksheet = workbook.Sheets[sheetName];
			const csvText = XLSX.utils.sheet_to_csv(worksheet);

			console.log("csvText=============>", csvText);

			// const veb_schema = Plan.map((plan) => ({
			// 	carrier_name: plan.carrier_name,
			// 	coverage_for: Array.isArray(plan.coverage_for?.options) ? plan.coverage_for.options : [],
			// 	coverage_volume: Array.isArray(plan.coverage_volume?.options) ? plan.coverage_volume.options : [],
			// 	pay_frequency: Array.isArray(plan.pay_frequency?.options) ? plan.pay_frequency.options : []
			// }));
			const veb_schema = Object.values(formData).map((entry: any) => ({
				carrier_name: entry.carrier_name,
				coverage_for: Array.isArray(entry.coverage_for?.options) ? entry.coverage_for.options : [],
				coverage_volume: Array.isArray(entry.coverage_volume?.options) ? entry.coverage_volume.options : [],
				pay_frequency: Array.isArray(entry.pay_frequency?.options) ? entry.pay_frequency.options : []
			}));
			let basePlanHierarchy;

			// Now build basePlanHierarchy for each plan
			const planHierarchies = veb_schema.map((schema) => {
				basePlanHierarchy = "standard_premium";

				if (schema.coverage_for.length > 0) basePlanHierarchy += " -> coverage_for";

				if (schema.coverage_volume.length > 0) basePlanHierarchy += " -> coverage_volume";

				if (schema.pay_frequency.length > 0) basePlanHierarchy += " -> pay_frequency";

				return {
					carrier_name: schema.carrier_name,
					basePlanHierarchy
				};
			});

			// coverage for
			// 1.example json
			// standard_premium:{
			//    Employee Only:{MONTHLY:0,WEEKLY:0,BIWEEKLY:0}
			//  }

			// coverage for + smoke
			// 1.example json
			// standard_premium:{
			// smoker{
			//    Employee Only:{MONTHLY:0,WEEKLY:0,BIWEEKLY:0}
			//  }}
			// non_smoker{
			//    Employee Only:{MONTHLY:0,WEEKLY:0,BIWEEKLY:0}
			//  }}

			// coverage for + coverage volume
			// 1.example json
			// standard_premium:{
			// sjakshj{
			//    Employee Only:{MONTHLY:0,WEEKLY:0,BIWEEKLY:0}
			//  }}
			// alscbajls{
			//    Employee Only:{MONTHLY:0,WEEKLY:0,BIWEEKLY:0}
			//  }}

			// coverage for + coverage volume + smoker
			// 1.example json
			// standard_premium:{
			// smoker:{
			// plan1{
			//    Employee Only:{MONTHLY:0,WEEKLY:0,BIWEEKLY:0}
			//  }}
			// plan2{
			//    Employee Only:{MONTHLY:0,WEEKLY:0,BIWEEKLY:0}
			//  }}}
			// non_smoker:{
			// plan1{
			//    Employee Only:{MONTHLY:0,WEEKLY:0,BIWEEKLY:0}
			//  }}
			// plan2{
			//    Employee Only:{MONTHLY:0,WEEKLY:0,BIWEEKLY:0}
			//  }}}

			// benefit amount
			// 1.example json
			// standard_premium:{
			//    Employee Only:{10:{MONTHLY:0,WEEKLY:0,BIWEEKLY:0}}
			//  }

			// benefit amount + snoker
			// 1.example json
			// standard_premium:{
			// smoker{
			//    Employee Only:{10:{MONTHLY:0,WEEKLY:0,BIWEEKLY:0}}
			//  }}
			// non_smoker{
			//    Employee Only:{10:{MONTHLY:0,WEEKLY:0,BIWEEKLY:0}}
			//  }}

			// benefit amount + coverage volume
			// 1.example json
			// standard_premium:{
			// plan1{
			//    Employee Only:{10:{MONTHLY:0,WEEKLY:0,BIWEEKLY:0}}
			//  }}
			// plan2{
			//    Employee Only:{10:{MONTHLY:0,WEEKLY:0,BIWEEKLY:0}}
			//  }}

			// benefit amount + coverage volume + smoker
			// 1.example json
			// standard_premium:{
			// smoker:{
			// plan1{
			//    Employee Only:{10:{MONTHLY:0,WEEKLY:0,BIWEEKLY:0}}
			//  }}
			// plan2{
			//    Employee Only:{10:{MONTHLY:0,WEEKLY:0,BIWEEKLY:0}}
			//  }}}
			// non_smoker:{
			// plan1{
			//    Employee Only:{10:{MONTHLY:0,WEEKLY:0,BIWEEKLY:0}}
			//  }}
			// plan2{
			//    Employee Only:{10:{MONTHLY:0,WEEKLY:0,BIWEEKLY:0}}
			//  }}}

			const prompt = `
	You are an expert MERN stack developer and data transformation agent.
	Your task is to read the provided CSV (converted from Excel) and output a single valid JSON object.

	This JSON will be stored in a database and later used for premium calculation, so it is **very sensitive** and must be accurate.

	Rules:
		1.example json
			standard_premium:{
			   Employee Only:{MONTHLY:0,WEEKLY:0,BIWEEKLY:0}
			 }
	2.do not miss any value each value should be added in json and do not miss any benefit amount
	3. Do not use the literal string "property" as a JSON key.
	4. Do not add any extra nesting level or key between coverage_volume and pay_frequency.
	5. Do not add any extra key or numeric index between coverage_volume and pay_frequency.
	   The pay_frequency keys (e.g., WEEKLY, MONTHLY) must directly contain numeric values (default 0).
	6. You are **fully responsible** for placing the correct numeric values from the CSV at the correct position in the JSON hierarchy.
	7. Output must be **only valid JSON** with no extra commentary. do not add carrier_name as key
	Here is the CSV data:
	${csvText}
	`;

			try {
				const model = genAI.getGenerativeModel({ model: "gemini-2.0-flash" });
				const result = await model.generateContent(prompt);
				let outputText = result.response.text().trim();
				outputText = outputText.replace(/```json|```/g, "").trim();
				const jsonData = JSON.parse(outputText);
				setJsonOutput(jsonData);
				console.log("Generated JSON:", jsonData);
			} catch (err) {
				console.error(" Error generating JSON:", err);
			} finally {
				setLoading(false);
			}
		};
		reader.readAsArrayBuffer(file);
	};

	const handleSubmit = async () => {
		try {
			// Normalize pay frequency to uppercase
			// if (!validateForm()) return;
			if (!planId) return alert("Plan ID is missing!");
			const normalizedPayFrequency = (formData.pay_frequency || []).map((pf: string) => pf.toUpperCase());
			console.log("Normalized Pay Frequency:", normalizedPayFrequency);
			console.log("Demo", formData);
			console.log(
				"Benefit Amount",

				formData["age_criteria.enable_specific_ages"],
				formData["dependent_eligibility.is_each_relationship_has_diffrent_premium"],
				formData["dependent_eligibility.spouse.min_age"],
				formData["dependent_eligibility.spouse.can_spouse_has_max_benefit_amount_than_employee"],
				formData["dependent_eligibility.children.min_age"],
				formData["benefit_amount.min_benefit"],
				formData["benefit_amount.each_benefit_multiply_by"],
				formData["benefit_amount.max_benefit"],
				formData["is_this_plan_has_age_criteria"],
				formData["is_premium_depends_on_smoke"]
				// formData,

				// formData["coverage_volume_present.is_present"]
			);
			const benifitOptions = generateBenefitOptions(
				formData["benefit_amount.min_benefit"],
				formData["benefit_amount.max_benefit"],
				formData["benefit_amount.each_benefit_multiply_by"]
			);
			const specific_age_list = generateSpecificAgeListOptions(
				formData["age_criteria.min_age"],
				formData["age_criteria.max_age"]
			);
			console.log("specific_age_list", specific_age_list);

			const payload = {
				// group_number: queryGroupNumber as number,
				// carrier_name: {
				// 	value: createdPlan?.carrier_name || "",
				// 	type: "string",
				// 	is_present: true,
				// 	is_visible_in_form: true
				// },

				auto_approve: createdPlan.auto_approve,
				is_premium_depends_on_smoke: formData["is_premium_depends_on_smoke"] || false,

				// --- Form Fields ---
				coverage_for: {
					options: formData.coverage_for,
					is_present: true,
					is_visible_in_form: true
				},
				coverage_volume: {
					options: formData.coverage_volume,
					is_present: formData["coverage_volume_present"] || false,
					is_visible_in_form: true
				},
				pay_frequency: {
					options: formData.pay_frequency,
					is_present: true,
					is_visible_in_form: true
				},

				premium_amount: jsonOutput || null,

				// --- Benefit Amount ---
				benefit_amount: {
					is_present: formData.is_benefit || false,
					is_visible_in_form: false,
					min_benefit: formData["benefit_amount.min_benefit"] || 0,
					max_benefit: formData["benefit_amount.max_benefit"] || 0,
					each_benefit_multiply_by: formData["benefit_amount.each_benefit_multiply_by"] || 1,
					options: benifitOptions || []
				},

				// --- Age Criteria ---
				is_this_plan_has_age_criteria: formData.age_criteria?.is_present || false,
				age_criteria: {
					is_present: formData["is_this_plan_has_age_criteria"] || false,
					is_visible_in_form: false,
					use_specific_ages: formData["age_criteria.enable_specific_ages"] || false,
					min_age: formData["age_criteria.min_age"] || 0,
					max_age: formData["age_criteria.max_age"] || 0,
					age_step: 0,
					specific_age_list: specific_age_list || [],
					use_age_bands: formData["age_criteria.use_age_bands"] || false,
					age_band_ranges: formData["age_criteria.age_band_ranges"] || []
				},

				// --- Dependent Eligibility ---
				dependent_eligibility: {
					is_each_relationship_has_diffrent_premium:
						formData["dependent_eligibility.is_each_relationship_has_diffrent_premium"] || false,
					spouse: {
						min_age: formData["dependent_eligibility.spouse.min_age"] || 0,
						max_age: formData["dependent_eligibility.spouse.max_age"] || 0,
						can_spouse_has_max_benefit_amount_than_employee:
							formData["dependent_eligibility.spouse.can_spouse_has_max_benefit_amount_than_employee"]
					},
					children: {
						min_age: formData["dependent_eligibility.children.min_age"] || 0,
						max_age: formData["dependent_eligibility.children.max_age"] || 0,
						can_children_has_max_benefit_amount_than_employee:
							formData[
								"dependent_eligibility.children.can_children_has_max_benefit_amount_than_employee"
							],
						disabled: {
							min_age: formData["dependent_eligibility.children.disabled.min_age"] || 0,
							max_age: formData["dependent_eligibility.children.disabled.max_age"] || 0,
							children_can_exceed_employee_benefit:
								formData["dependent_eligibility.children.disabled.children_can_exceed_employee_benefit"]
						}
					},
					eligible_relationship: formData["dependent_eligibility.eligible_relationship"],
					in_eligible_relationship: formData["dependent_eligibility.in_eligible_relationship"]
				},

				// --- Riders ---
				is_this_plan_has_riders: false,
				rider: {
					name: "",
					is_rider_only_for_employee: false,
					is_required: false,
					coverage_for: {
						options: [],
						is_present: true,
						is_visible_in_form: true
					},
					coverage_volume: {
						options: [],
						is_present: true,
						is_visible_in_form: true
					},
					pay_frequency: {
						options: ["WEEKLY", "BIWEEKLY", "MONTHLY"],
						is_present: true,
						is_visible_in_form: true
					},
					benefit_amount: {
						is_present: false,
						is_visible_in_form: false,
						min_benefit: 0,
						max_benefit: 0,
						each_benefit_multiply_by: 1,
						options: []
					},
					is_premium_depends_on_smoke: false,
					age_criteria: {
						is_present: false,
						is_visible_in_form: false,
						use_specific_ages: false,
						min_age: 0,
						max_age: 0,
						age_step: 0,
						specific_age_list: [],
						use_age_bands: false,
						age_band_ranges: []
					},
					dependent_eligibility: {
						is_each_relationship_has_diffrent_premium: false,
						spouse: {
							min_age: 0,
							max_age: 0,
							can_spouse_has_max_benefit_amount_than_employee: false
						},
						children: {
							min_age: 0,
							max_age: 0,
							can_children_has_max_benefit_amount_than_employee: false,
							disabled: {
								min_age: 0,
								max_age: 0,
								children_can_exceed_employee_benefit: false
							}
						},
						eligible_relationship: [],
						in_eligible_relationship: []
					}
				}
			};

			console.log("Payload to send:", payload);

			const excelPayload = {
				carrier_name: {
					value: createdPlan?.carrier_name || "",
					type: "string",
					is_present: true,
					is_visible_in_form: true
				},
				...payload
			};

			console.log("Sanitized Payload:", payload);
			if (step == 4) {
				await trackPromise(api.plan.updateVEBPlan(planId, payload));
				await jsonToExcel(`${createdPlan.plan_name}_PREMIUM.xlsx`, excelPayload);
			}

			// alert("Plan updated successfully!");

			// const { jsonToExcelObject, planTitle } = generateJsonForExcel();
			if (step == steps.length) {
				if (jsonOutput) {
					await trackPromise(api.plan.updateVEBPlan(planId, payload));

					alert("Plan Saved as Draft!");
					navigate(`/employer/plan-management?gn=${queryGroupNumber}`);
				}
			}
		} catch (err: any) {
			console.error(err);
			alert(err.response?.data?.message || "Failed to update plan");
		}
	};

	return (
		<div className="create-static-plan">
			{/* <Typography variant="subtitle2" sx={{ mb: 1 }}>
				Step {step} of 4
			</Typography>
			<LinearProgress variant="determinate" value={(step / 4) * 100} /> */}
			<Box
				// sx={{ mb: 3 }}
				sx={{
					// display: "flex",
					mb: 3,
					justifyContent: "space-between",
					mt: 3,
					background: "linear-gradient(145deg, #f0f0f0, #cacaca)",
					boxShadow: "5px 5px 15px #b8b8b8, -5px -5px 15px #ffffff",
					borderRadius: "12px",
					transition: "all 0.3s ease",
					transform: "translateY(0px)",
					"&:hover": {
						transform: "translateY(-3px)", // subtle lift on hover
						boxShadow: "8px 8px 20px #b8b8b8, -8px -8px 20px #ffffff" // deeper shadow on hover
					}
				}}
			>
				<Stepper activeStep={step - 1} alternativeLabel>
					{steps.map((label) => (
						<Step key={label}>
							{/* <StepLabel>{label}</StepLabel>
							 */}
							<StepLabel StepIconComponent={GreenStepIcon}>{label}</StepLabel>
						</Step>
					))}
				</Stepper>

				{/* Optional linear progress under the Stepper */}
				<LinearProgress
					variant="determinate"
					value={(step / steps.length) * 100}
					sx={{
						height: 10,
						borderRadius: 5,
						mt: 1,
						bgcolor: "#e0e0e0", // track background
						"& .MuiLinearProgress-bar": {
							borderRadius: 5,
							backgroundColor: "green" // filled bar
						}
					}}
				/>
			</Box>

			<Paper className="pf-paper-container static-plan-container" elevation={3} variant="outlined" sx={{ p: 2 }}>
				<form>{stepFields(step).map((field) => renderField(field))}</form>
			</Paper>

			<Box sx={{ display: "flex", justifyContent: "space-between", mt: 3, boxShadow: "initial" }}>
				{/* Back button */}
				{step > 1 && (
					<Button variant="outlined" onClick={handleBack}>
						Back
					</Button>
				)}

				{/* Conditional next/complete/excel buttons */}
				{(() => {
					if (step === 4) {
						return (
							<Button
								variant="contained"
								color="success"
								onClick={() => {
									handleSubmit();
									handleNext();
								}}
							>
								Generate Excel
							</Button>
						);
					} else if (step < 4) {
						return (
							<Button
								variant="contained"
								color="success"
								onClick={() => {
									handleSubmit();
									handleNext();
								}}
							>
								Next
							</Button>
						);
					} else if (step === 5) {
						return (
							<Button
								variant="contained"
								color="success"
								onClick={async () => {
									if (!jsonOutput) {
										handleConvert();
									}

									handleSubmit();
								}}
								disabled={loading}
							>
								{loading ? "Loading..." : "Complete"}
							</Button>
						);
					}

					return null;
				})()}
			</Box>
		</div>
	);
};

export default ExcelToJson;
